import React from 'react';
import {motion} from 'framer-motion';

const HeroSection = () => {
  const scrollToValuation = () => {
    document.getElementById('valuation')?.scrollIntoView({behavior: 'smooth'});
  };

  return (
    <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-blue-900 text-white overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://www.shutterstock.com/image-photo/experienced-technician-inspecting-air-conditioning-600nw-2485364991.jpg"
          alt="HVAC Technician Working"
          className="w-full h-full object-cover opacity-20"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 to-blue-900/60 z-10"></div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{opacity: 0, x: -20}}
            animate={{opacity: 1, x: 0}}
            transition={{duration: 0.8}}
            className="text-center lg:text-left"
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">
              Sell Your{' '}
              <span className="text-blue-400">HVAC Company</span>{' '}
              with Confidence
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed">
              We help HVAC owners exit successfully with qualified buyers, confidentially.
            </p>

            <motion.button
              onClick={scrollToValuation}
              whileHover={{scale: 1.05}}
              whileTap={{scale: 0.95}}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold shadow-xl transition-all duration-300 transform hover:shadow-2xl"
            >
              Get a Free Valuation
            </motion.button>
          </motion.div>

          <motion.div
            initial={{opacity: 0, x: 20}}
            animate={{opacity: 1, x: 0}}
            transition={{duration: 0.8, delay: 0.2}}
            className="hidden lg:block"
          >
            <div className="relative">
              <img
                src="https://www.shutterstock.com/image-photo/experienced-technician-inspecting-air-conditioning-600nw-2485364991.jpg"
                alt="HVAC Technician Working"
                className="rounded-lg shadow-2xl"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/30 to-transparent rounded-lg"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;